import ConfiguratorButton from "./components/ConfiguratorButton";

const Customizer = () => {
    return <ConfiguratorButton/>
}

export default Customizer;
